import React, { useState, useEffect } from "react";
import BillRecap from "Components/BillRecap/BillRecap";
import Button from "Components/button/Button";
import ServicesRecapTable from "Components/servicesRecapTable/ServicesRecapTable";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
import useDeliveryPrices from "Utils/useDeliveryPrices";
import { formatServerErrors } from "Utils/serverFormats";
import SmallModal from "Components/smallModal/smallModal";
import { useHistory } from "react-router-dom";

const formatter = new Intl.NumberFormat(navigator.language || navigator.userLanguage, {
  maximumFractionDigits: 0,
});

const Recap = ({
  stepper,
  formData,
  accountData,
  onFormCancel,
  api,
  setFormErrors,
  isFormLoading,
  unsetFormLoading,
  setFormLoading,
  setNewUserData,
  handleFormResponseErrors,
  setFormFieldValue,
  isReseller,
  onFormSubmit = () => {},
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const history = useHistory();

  const [price, setPrice] = useState(null);

  const { prices, getExtraPack } = useDeliveryPrices();

  useEffect(() => {
    if (!accountData) return;

    const extraPackage = getExtraPack(accountData.type);
    setFormFieldValue({ product_id: extraPackage.id });

    let price = formData.volume * extraPackage.unit_pricing_eur;
    if (isReseller) {
      price = formData.volume * extraPackage.reseller_tier.pricing_eur;
    }

    setPrice(price);
  }, [prices, formData.volume, accountData]);

  const submitForm = async (e) => {
    e.preventDefault();

    setFormLoading(true);

    let errored = false;
    try {
      await api.updateDeliveryAccountInfo({
        id: accountData.id,
        volume: formData.volume,
        productId: formData.product_id,
      });
      setFormErrors({});
    } catch (response) {
      errored = true;
      console.log(response);
      const errors = await formatServerErrors(response);
      setFormErrors(errors);
    }

    unsetFormLoading(false);

    if (errored) return;

    onFormSubmit();
    setIsModalOpen(true);
  };

  const modalTitle = t("delivery.accounts.update.stepRecap.modal.title");
  const modalInfo = t("delivery.accounts.update.stepRecap.modal.info.prepaid");

  return (
    <div className="screenContainer flexAlignCenter">
      {stepper}

      <div className="mt-4 w-full max-w-[--form-page-width]">
        <div className="sectionTitle">{t("delivery.accounts.extradelivery.stepRecap.title")}</div>
        <div className="sectionDesc">{t("delivery.accounts.extradelivery.stepRecap.desc")}</div>
      </div>
      <form className="formContainer" onSubmit={submitForm}>
        <div className="flex flex-col w-full gap-10">
          <ServicesRecapTable
            className={"expand formSection"}
            tableName={`${t("delivery.accounts.extradelivery.stepRecap.table.title")} ${accountData.description}`}
            servicesData={[
              {
                name: t("delivery.accounts.add.stepPlan.volume.title"),
                value: formatter.format(formData.volume * 1000),
              },
            ]}
          />
          <BillRecap
            className="expand"
            title={t("delivery.accounts.add.stepPlan.priceRecapLabel")}
            price={price}
            infoFee={<TranslatedString>order.fee.priceVat</TranslatedString>}
          />
        </div>
        <div className="formFooter">
          <Button color="text" type="button" onClick={onFormCancel}>
            button.cancel
          </Button>
          <Button loading={isFormLoading} color="green">
            button.order
          </Button>
        </div>
      </form>

      <SmallModal modalClassName="" title={modalTitle} opened={isModalOpen}>
        <div className="section">{modalInfo}</div>
        <div className="mb-4">
          <Button className="self-end" type="button" color="accent" onClick={() => history.push("/delivery/accounts")}>
            button.ok
          </Button>
        </div>
      </SmallModal>
    </div>
  );
};

export default Recap;
